import * as React from 'react';
var AnchorContext = /*#__PURE__*/React.createContext(undefined);
export default AnchorContext;